import { render } from "./selectTree.vue?vue&type=template&id=6f40fd81"
import script from "./selectTree.vue?vue&type=script&lang=js"
export * from "./selectTree.vue?vue&type=script&lang=js"

import "./selectTree.vue?vue&type=style&index=0&id=6f40fd81&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__